<template>
  <div class="sidebar">
      <div class="sideberitem" @click="pageurl('/layout/meorder')" :style="{color:this.$route.path==='/layout/meorder'?'#FF4444':''}">我的订单</div>
      <div class="sideberitem" @click="pageurl('/layout/adress')" :style="{color:this.$route.path==='/layout/adress'?'#FF4444':''}">收货地址</div>
      <div class="sideberitem" @click="pageurl('/layout/personage')" :style="{color:this.$route.path==='/layout/personage'?'#FF4444':''}">个人信息</div>
      <div class="sideberitem" @click="pageurl('/layout/balance')" :style="{color:this.$route.path==='/layout/balance'?'#FF4444':''}">零钱</div>
      <div class="sideberitem" @click="pageurl('/layout/integral')" :style="{color:this.$route.path==='/layout/integral'?'#FF4444':''}">味豆</div>
      <div class="sideberitem" v-if="mch_type==2" @click="pageurl('/layout/password')" :style="{color:this.$route.path==='/layout/password'?'#FF4444':''}">修改密码</div>
  </div>
</template>

<script>
  export default {
    name: 'sidebar',
    data(){
      return{
        mch_type:""
      }
    },
    components:{

    },
    created() {
       // var mch_type= JSON.parse(sessionStorage.getItem("total")).mch_info.mch_type
       this.mch_type = JSON.parse(sessionStorage.getItem("total")).mch_info.mch_type
       console.log(JSON.parse(sessionStorage.getItem("total")).mch_info.mch_type);
    },
    methods:{
      pageurl(url){
        console.log(url)
        this.$router.push({
          path:url
        })
      }
    }
  }
</script>

<style lang="less">
  .sidebar{
    padding-top: 30px;
    width: 100%;
    padding-left: 80px;
    box-sizing: border-box;
    .sideberitem{
      font-size: 14px;
      cursor: pointer;
      height: 40px;
      line-height: 40px;
    }
  }


</style>



// WEBPACK FOOTER //
// src/views/layout/components/sidebar.vue